import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import user from "./plugins/UserService";
import VueFilterDateFormat from "@vuejs-community/vue-filter-date-format";

Vue.use(user);
Vue.use(VueFilterDateFormat);

const moment = require("moment");
require("moment/locale/da");

Vue.use(require("vue-moment"), {
  moment,
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");

if (window.Element && !Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
      i,
      el = this;
    do {
      i = matches.length;
      while (--i >= 0 && matches.item(i) !== el) {}
    } while (i < 0 && (el = el.parentElement));
    return el;
  };
}
